import { array, string as yupString } from "yup";
import { Device, Local, Addresses, Ntp } from "./types";
import {
  Enum_DateFormat,
  Enum_TimeFormat,
  Enum_TimeServerMode,
  Enum_TimeZone
} from "generated/graphql";
import i18next from "utilities/i18n";
import {
  isValidIpOrDomain,
  stringF,
  mixedEnum,
  boolean,
  object
} from "./helpers";

export const local = object<Local>({
  autoDaylightSavings: object({
    enable: boolean("AUTO_ADJUST_DAYLIGHT_SAVINGS")
  }),
  timezone: mixedEnum(Enum_TimeZone, "TIME_ZONE").default(Enum_TimeZone.Cst),
  datetime: object({
    date: object({
      format: mixedEnum(Enum_DateFormat, "DATE_FORMAT").default(
        Enum_DateFormat.MmDdYyyy
      )
    }),
    time: object({
      TWO4HourClock: mixedEnum(Enum_TimeFormat, "TIME_FORMAT").default(
        Enum_TimeFormat.One2Hour
      )
    })
  }),
  ntpServer: object<Ntp>({
    address: array<Addresses>()
      .of(
        yupString()
          .label("TIME_SERVER_ADDRESS")
          .nullable(false) //string.required also strips "" which we need to allow.
          .default("")
      )
      .default([])
      .when("mode", {
        is: Enum_TimeServerMode.Manual,
        then: array().of(
          stringF("TIME_SERVER_ADDRESS").test(
            "validate-domain",
            i18next.t("ERROR_NTP_ADDRESS"),
            isValidIpOrDomain
          )
        )
      })
      .nullable(),
    mode: mixedEnum(Enum_TimeServerMode, "TIME_SERVER").default(
      Enum_TimeServerMode.Auto
    )
  })
});

export const device = object<NonNullable<Device>>({
  local
});
